import { render, staticRenderFns } from "./KvmDockerStacks.vue?vue&type=template&id=0cfbeb18&scoped=true&"
import script from "./KvmDockerStacks.vue?vue&type=script&lang=js&"
export * from "./KvmDockerStacks.vue?vue&type=script&lang=js&"
import style0 from "./KvmDockerStacks.vue?vue&type=style&index=0&id=0cfbeb18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfbeb18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cfbeb18')) {
      api.createRecord('0cfbeb18', component.options)
    } else {
      api.reload('0cfbeb18', component.options)
    }
    module.hot.accept("./KvmDockerStacks.vue?vue&type=template&id=0cfbeb18&scoped=true&", function () {
      api.rerender('0cfbeb18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmDockerStacks.vue"
export default component.exports